import oAxiosInstance from "config/Axios";

export const apiCallGetAllIVAs = () => {
  return oAxiosInstance.get("iva");
};
